import React, {useState, useEffect} from 'react'
import {getDepartmentsWithPage} from '../../services/serviceDepartment'
import {Button, Card, Table} from "antd";
import DepartmentActions from "./DepartmentActions";
import DepartmentCreate from "./DepartmentCreate";

const Department = () => {
    const [sortedList, setSortedList] = useState([])
    const [newModal, setNewModal] = useState(false)
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });

    useEffect(() => {
        getDepartments(pagination.current, pagination.pageSize);
    }, [pagination.current, pagination.pageSize])

    const getDepartments = (page, pageSize) => {
        getDepartmentsWithPage(page - 1, pageSize)
            .then(({data}) => {
                handlers.sortData(data.content);
                setPagination({
                    ...pagination,
                    total: data.totalElements,
                })
        })
    };

    const handlers = {
        updater(){
            getDepartments(1, 10);
        },
        modalCloser(){
            setNewModal(!newModal)
        },
        sortData(list){
            let sorted = []
            list.forEach((item) => {
                let pushObj = {
                    key: item.id,
                    id: item.id,
                    deptName: item.name,
                    deptCode: item.code
                }
                sorted.push(pushObj)
            })
            setSortedList(sorted)
        }
    };

    const handlePaginationChange = (pageNumber, pageSize) => {
        setPagination({
            ...pagination,
            current: pageNumber,
            pageSize: pageSize
        });
    };


    const columns= [
        {
            title: 'Adı',
            dataIndex: 'deptName',
            key: 'deptName'
        },
        {
            title: 'Kodu',
            dataIndex: 'deptCode',
            key: 'deptCode'
        },
        {
            title: 'İşlemler',
            key: 'action',
            render: (text, record) => <DepartmentActions record={record} updater={handlers.updater}/>
        }
    ];

    return (
        <React.Fragment>
            <Card title={'Departman Listesi'} extra={<Button  onClick={()=>setNewModal(!newModal)} type={'primary'}>Yeni Ekle</Button>}>
                <Table 
                scroll={{x: 'max-content'}} 
                columns={columns} 
                dataSource={sortedList}
                pagination={{
                    ...pagination,
                    showSizeChanger: true,
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    onChange: handlePaginationChange,
                }}
                />
            </Card>

            {newModal ? <DepartmentCreate show={newModal} modalCloser={handlers.modalCloser} updater={handlers.updater}/> : null }


        </React.Fragment>
    )
}

export default Department